<template>
  <v-menu
    left
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="300"
    max-width="350"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn icon
                 v-on="{ ...onTooltip, ...on }"
                 @click.stop.prevent=""
          >
            <v-icon>mdi-format-list-bulleted</v-icon>
          </v-btn>
        </template>
        <span>Opções de visualização</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="font-weight-bold">
        Opções de visualização
      </v-card-title>
      <v-card-text class="text--primary">
        <v-row dense>
          <v-col cols="12">
            <px-select-enum label="Tipo de visualização"
                            class="rounded-tag-small"
                            dense
                            v-model="tipoVisualizacao"
                            :items="tiposVisualizacao"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-switch label="Exibir especificações"
                      v-model="showEspecificacao"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-switch label="Exibir especificações do fornecedor"
                      v-model="showEspecificacaoFornecedor"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-switch label="Exibir preços sem ICMS"
                      v-model="showPrecoSemIcms"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-switch label="Exibir percentual ICMS"
                      v-model="showPercentualIcms"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-switch label="Exibir preço target do produto"
                      v-model="showPrecoTarget"/>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    cotacoes: Array,
  },
  data: () => ({
    menuOpened: false,
    fornecedoresLocal: null,
    cotacoesItensLocal: null,
    tiposVisualizacao: [{
      key: 'PRODUTO',
      description: 'Produto',
    }, {
      key: 'FORNECEDOR',
      description: 'Fornecedor',
    }],
  }),
  computed: {
    showEspecificacao: {
      get() {
        return this.$store.getters['matriz/showEspecificacao'];
      },
      set(showEspecificacao) {
        this.$store.dispatch('matriz/showEspecificacao', showEspecificacao);
      },
    },
    showEspecificacaoFornecedor: {
      get() {
        return this.$store.getters['matriz/showEspecificacaoFornecedor'];
      },
      set(showEspecificacaoFornecedor) {
        this.$store.dispatch('matriz/showEspecificacaoFornecedor', showEspecificacaoFornecedor);
      },
    },
    showPrecoSemIcms: {
      get() {
        return this.$store.getters['matriz/showPrecoSemIcms'];
      },
      set(showPrecoSemIcms) {
        this.$store.dispatch('matriz/showPrecoSemIcms', showPrecoSemIcms);
      },
    },
    tipoVisualizacao: {
      get() {
        return this.$store.getters['matriz/tipoVisualizacao'];
      },
      set(tipoVisualizacao) {
        this.$store.dispatch('matriz/tipoVisualizacao', tipoVisualizacao);
      },
    },
    showPercentualIcms: {
      get() {
        return this.$store.getters['matriz/showPercentualIcms'];
      },
      set(showPercentualIcms) {
        this.$store.dispatch('matriz/showPercentualIcms', showPercentualIcms);
      },
    },
    showPrecoTarget: {
      get() {
        return this.$store.getters['matriz/showPrecoTarget'];
      },
      set(showPrecoTarget) {
        this.$store.dispatch('matriz/showPrecoTarget', showPrecoTarget);
      },
    },
  },
};
</script>
